import { TERMS_VERSION } from "../constants/terms/terms-html";

type TermsStorage = {
  /** 同意した利用規約のバージョン */
  version: string;
  /** 利用規約に同意済みかどうか */
  agreed: boolean;
};

export class TermsAgreementManager {
  private static STORE_KEY = 'ppm-cloud-terms';
  private static CURRENT_VERSION = TERMS_VERSION;

  private static load(): TermsStorage {
    const raw = localStorage.getItem(this.STORE_KEY);
    if (!raw) {
      return this.createInitial();
    }
    try {
      return JSON.parse(raw) as TermsStorage;
    } catch {
      return this.createInitial();
    }
  }

  private static createInitial(): TermsStorage {
    return {
      version: this.CURRENT_VERSION,
      agreed: false,
    };
  }

  private static save(data: TermsStorage): void {
    localStorage.setItem(this.STORE_KEY, JSON.stringify(data));
  }

  /** 最新バージョンの利用規約に同意済みかどうかを判断する */
  static hasAgreed(): boolean {
    const data = this.load();
    return data.agreed && data.version === this.CURRENT_VERSION;
  }

  /** 最新バージョンの利用規約に同意したことを記録する */
  static agree(): void {
    this.save({
      version: this.CURRENT_VERSION,
      agreed: true,
    });
  }
}
